// extracted by mini-css-extract-plugin
module.exports = {"checkboxCenter":"styles_checkboxCenter__EVBlg"};